import React, {ReactElement} from 'react';
import {useDispatch} from 'react-redux';
import {jumpToSlideWithIdAction} from '../../../../store/actions/presentation.actions';
import {IElementCircle} from '../../../../incase-domain/elements/shapes/circle';
import {SHAPE_COLOR_DEFAULT} from '../../../../constants';

interface CircleProps {
    element: IElementCircle;
    thickness?: number;
}

Circle.defaultProps = {
    thickness: 0.0625,
};

function Circle(props: CircleProps): ReactElement {
    const {element, thickness} = props;
    const {fill, color, slideChange} = element;

    const dispatch = useDispatch();

    if (fill) {
        return (
            <div className="c-circle" onClick={() => dispatch(jumpToSlideWithIdAction(slideChange.slideId, true))}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 24.394 24.394"
                    xmlSpace="preserve"
                    fill={color || '#494949'}
                >
                    <g>
                        <g id="b80_food">
                            <circle cx="12.197" cy="12.197" r="12.197" />
                        </g>
                        <g id="Capa_1_82_" />
                    </g>
                </svg>
            </div>
        );
    }

    return (
        <div className="c-circle" onClick={() => dispatch(jumpToSlideWithIdAction(slideChange.slideId, true))}>
            <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill={color || SHAPE_COLOR_DEFAULT}
                    stroke={color || SHAPE_COLOR_DEFAULT}
                    strokeWidth={`${thickness}em`}
                    d="M256 23.05C127.5 23.05 23.05 127.5 23.05 256S127.5 488.9 256 488.9 488.9 384.5 488.9 256 384.5 23.05 256 23.05zm0
                17.9c118.9 0 215.1 96.15 215.1 215.05S374.9 471.1 256 471.1c-118.9 0-215.05-96.2-215.05-215.1C40.95 137.1 137.1 40.95
                 256 40.95z"
                />
            </svg>
        </div>
    );
}

export default Circle;
